<template>
  <div class="module-detail-container">
    <!-- 主内容区 -->
    <div class="module-content">
      <!-- 1. 模块专属图片 -->
      <div class="module-specific-image">
        <img :src="currentModule.url" :alt="currentModule.title" />
      </div>

      <div class="content">
        <div class="content_item">
          <div class="CarbonFootprint_top">
            <img
              class="camre img"
              :src="require('@/assets/recycling/index/camre.png')"
              alt=""
            />
          </div>
          <p class="title">摄像头接入</p>
          <p class="main">
            会员企业摄像头接入，远程可进行管理监控，对于问题企业，可以有效的根据视频资料，追溯其问题。
          </p>
        </div>
        <div class="content_item">
          <div class="CarbonFootprint_top">
            <img
              class="punish img"
              :src="require('@/assets/recycling/index/punish.png')"
              alt=""
            />
          </div>
          <p class="title">处罚数据统一管理</p>
          <p class="main">
            企业违规处理数据信息统一录入管理，让违规无处遁形！多种报表统计，让监控用户随时了解。
          </p>
        </div>
      </div>
    </div>
    <bottom-url />
  </div>
</template>

<script>
import bottomUrl from '@/components/bottomUrl/bottomUrl.vue';
import { scrollTop } from '@/util/scrollTop';
export default {
  components: {
    bottomUrl,
  },
  data() {
    return {
      // 8个模块的配置数据
      currentModule: {
        title: '溯源监管',
        url: require('@/assets/recycling/index/bg6.png'),
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.module-detail-container {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - 90px);
  overflow-y: auto;
  position: relative;
}

.module-content {
  width: 100%;
  text-align: center;
  padding-bottom: 200px; /* 为底部组件预留空间 */
  .content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px; /* 设置盒子之间的间距 */
    .content_item {
      width: 493px;
      height: 208px;
      background: #ebeef0;
      text-align: left;
      box-sizing: border-box;
      padding: 25px;
      .camre {
        width: 64px;
        height: 64px;
      }
      .punish {
        width: 74px;
        height: 64px;
      }
      .title {
        font-size: 20px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 28.96px;
        color: rgba(0, 0, 0, 1);
        margin: 20px 0 15px;
      }
      .main {
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 23.17px;
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }
}

/* 模块专属图片样式 */
.module-specific-image {
  width: 100%;
  height:730px;
  margin: 0 auto 48px;
  display: block;
}

.module-specific-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 开发中提示样式 */
.development-notice {
  background-color: #f8f9fa;
  border-radius: 6px;
  color: #6c757d;
  font-size: 18px;
  text-align: center;
  padding: 15px 0;
  margin: 0 auto;
  width: 80%;
  max-width: 500px;
}

@media screen and (max-width: 768px) {
  .module-detail-container {
    height: auto;
  }
  .module-content {
    height: auto;
    padding: 0 16px;
    background-size: 90% auto; /* 移动端适当缩小 */

    .content {
      flex-direction: column;
      margin: 8px 0 20px;
      width: 100%;
      .content_item {
        width: 100%;
        height: auto;
        margin: 8px 0;
        padding: 8px 10px;
        .CarbonFootprint_top {
            width: 70px;
            margin-top: 10px;
            .img {
              width: 50px;
              height: auto;
              margin: 0 10px;
            }
        }
        .title {
          font-size: 14px;
          line-height: normal;
        }
        .main {
          font-size: 12px;
          line-height: normal;
          margin: 10px 0;
        }
        .views {
          position: relative;
          bottom: 0;
          left: 0;
          margin: 10px;
          .views_box {
            height: 35px;
            justify-content: center;
            border-radius: 5px;
            span {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

</style>
